/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetTranslationJobResponse } from '../models';
// @ts-ignore
import type { GetTranslationJobsResponse } from '../models';
// @ts-ignore
import type { JobStatus } from '../models';
// @ts-ignore
import type { PaginationRequest } from '../models';
// @ts-ignore
import type { RetryAllJobsResponse } from '../models';
// @ts-ignore
import type { RetryTranslationJobResponse } from '../models';
/**
 * TranslationJobControllerApi - axios parameter creator
 * @export
 */
export const TranslationJobControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [days] 
         * @param {string} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyJobActivity: async (days?: number, projectId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/translation-jobs/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} jobType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById: async (id: string, jobType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobById', 'id', id)
            // verify required parameter 'jobType' is not null or undefined
            assertParamExists('getJobById', 'jobType', jobType)
            const localVarPath = `/translation-jobs/job/{id}/{jobType}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"jobType"}}`, encodeURIComponent(String(jobType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsByProjectId: async (projectId: string, paginationRequest: PaginationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getJobsByProjectId', 'projectId', projectId)
            // verify required parameter 'paginationRequest' is not null or undefined
            assertParamExists('getJobsByProjectId', 'paginationRequest', paginationRequest)
            const localVarPath = `/translation-jobs/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paginationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {JobStatus} jobState 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsByProjectIdAndJobState: async (projectId: string, jobState: JobStatus, paginationRequest: PaginationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getJobsByProjectIdAndJobState', 'projectId', projectId)
            // verify required parameter 'jobState' is not null or undefined
            assertParamExists('getJobsByProjectIdAndJobState', 'jobState', jobState)
            // verify required parameter 'paginationRequest' is not null or undefined
            assertParamExists('getJobsByProjectIdAndJobState', 'paginationRequest', paginationRequest)
            const localVarPath = `/translation-jobs/project/{projectId}/state/{jobState}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"jobState"}}`, encodeURIComponent(String(jobState)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paginationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} translatableId 
         * @param {string} projectId 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsByTranslatableId: async (translatableId: string, projectId: string, paginationRequest: PaginationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'translatableId' is not null or undefined
            assertParamExists('getJobsByTranslatableId', 'translatableId', translatableId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getJobsByTranslatableId', 'projectId', projectId)
            // verify required parameter 'paginationRequest' is not null or undefined
            assertParamExists('getJobsByTranslatableId', 'paginationRequest', paginationRequest)
            const localVarPath = `/translation-jobs/translatable/{translatableId}`
                .replace(`{${"translatableId"}}`, encodeURIComponent(String(translatableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paginationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAllJobs: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('retryAllJobs', 'projectId', projectId)
            const localVarPath = `/translation-jobs/project/{projectId}/retry-all`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} jobType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedJob: async (id: string, jobType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryFailedJob', 'id', id)
            // verify required parameter 'jobType' is not null or undefined
            assertParamExists('retryFailedJob', 'jobType', jobType)
            const localVarPath = `/translation-jobs/job/{id}/{jobType}/retry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"jobType"}}`, encodeURIComponent(String(jobType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationJobControllerApi - functional programming interface
 * @export
 */
export const TranslationJobControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslationJobControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [days] 
         * @param {string} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyJobActivity(days?: number, projectId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyJobActivity(days, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.getDailyJobActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} jobType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobById(id: string, jobType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranslationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobById(id, jobType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.getJobById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsByProjectId(projectId: string, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranslationJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsByProjectId(projectId, paginationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.getJobsByProjectId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {JobStatus} jobState 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsByProjectIdAndJobState(projectId: string, jobState: JobStatus, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranslationJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsByProjectIdAndJobState(projectId, jobState, paginationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.getJobsByProjectIdAndJobState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} translatableId 
         * @param {string} projectId 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsByTranslatableId(translatableId: string, projectId: string, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranslationJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsByTranslatableId(translatableId, projectId, paginationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.getJobsByTranslatableId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryAllJobs(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetryAllJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryAllJobs(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.retryAllJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} jobType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryFailedJob(id: string, jobType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetryTranslationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryFailedJob(id, jobType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationJobControllerApi.retryFailedJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranslationJobControllerApi - factory interface
 * @export
 */
export const TranslationJobControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslationJobControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [days] 
         * @param {string} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyJobActivity(days?: number, projectId?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getDailyJobActivity(days, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} jobType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById(id: string, jobType: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTranslationJobResponse> {
            return localVarFp.getJobById(id, jobType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsByProjectId(projectId: string, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTranslationJobsResponse> {
            return localVarFp.getJobsByProjectId(projectId, paginationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {JobStatus} jobState 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsByProjectIdAndJobState(projectId: string, jobState: JobStatus, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTranslationJobsResponse> {
            return localVarFp.getJobsByProjectIdAndJobState(projectId, jobState, paginationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} translatableId 
         * @param {string} projectId 
         * @param {PaginationRequest} paginationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsByTranslatableId(translatableId: string, projectId: string, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTranslationJobsResponse> {
            return localVarFp.getJobsByTranslatableId(translatableId, projectId, paginationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAllJobs(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<RetryAllJobsResponse> {
            return localVarFp.retryAllJobs(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} jobType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedJob(id: string, jobType: string, options?: RawAxiosRequestConfig): AxiosPromise<RetryTranslationJobResponse> {
            return localVarFp.retryFailedJob(id, jobType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslationJobControllerApi - object-oriented interface
 * @export
 * @class TranslationJobControllerApi
 * @extends {BaseAPI}
 */
export class TranslationJobControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [days] 
     * @param {string} [projectId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public getDailyJobActivity(days?: number, projectId?: string, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).getDailyJobActivity(days, projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} jobType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public getJobById(id: string, jobType: string, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).getJobById(id, jobType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {PaginationRequest} paginationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public getJobsByProjectId(projectId: string, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).getJobsByProjectId(projectId, paginationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {JobStatus} jobState 
     * @param {PaginationRequest} paginationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public getJobsByProjectIdAndJobState(projectId: string, jobState: JobStatus, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).getJobsByProjectIdAndJobState(projectId, jobState, paginationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} translatableId 
     * @param {string} projectId 
     * @param {PaginationRequest} paginationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public getJobsByTranslatableId(translatableId: string, projectId: string, paginationRequest: PaginationRequest, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).getJobsByTranslatableId(translatableId, projectId, paginationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public retryAllJobs(projectId: string, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).retryAllJobs(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} jobType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationJobControllerApi
     */
    public retryFailedJob(id: string, jobType: string, options?: RawAxiosRequestConfig) {
        return TranslationJobControllerApiFp(this.configuration).retryFailedJob(id, jobType, options).then((request) => request(this.axios, this.basePath));
    }
}

